import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import FormField from '../layout/FormField';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';

const EditQRCode = () => {
    //--------------------------------------------
    const navigate = useNavigate();
    const location = useLocation();
    const { getToken } = useAuth();

    const data = location.state?.data;
    const validate = Yup.object({
        name: Yup.string().required('Name is required'),
        status: Yup.string().required('Status is required')
    });
    const handleSubmit = (values) => {
        // update status stationUpdate
        const token = getToken();
        new WebApiCalls()
            .stationUpdate(token, data?._id, { status: values?.status, name: values?.name })
            .then((res) => {
                if (res?.code === 200) {
                    toast.success('QRCode is  Updated successfully.');
                    navigate('/qr-codes');
                }
            })
            .catch((err) => {
                toast.success('Oops...! Something went wrong');
            });
    };
    //--------------------------------------------
    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={8} lg={11} className="shadow-lg p-5 m-3">
                    <Formik initialValues={{ ...data }} validationSchema={validate} onSubmit={handleSubmit} enableReinitialize={true}>
                        {(formik) => (
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            className="form-control common-input"
                                            label="Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter name"
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label>Status</label>
                                        <Field
                                            as="select"
                                            value={formik.values.status}
                                            name="status"
                                            className="status-selector-input"
                                            label="Status"
                                            onChange={formik.handleChange}
                                        >
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </Field>
                                    </Col>
                                </Row>

                                <div className="text-end">
                                    <Link to="/qr-codes">
                                        <Button className="theme-cancel-btn me-3">Cancel</Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
};

export default EditQRCode;
